import React, { useContext } from "react";
import moment from "moment";
import { useTranslation, Trans } from "react-i18next";
import Typography from "@mui/material/Typography";

import AppContext from "../../appContext";

export function useTime(timestamps) {
  const { i18n, t } = useTranslation();
  const getDate = (timestamp) => {
    return moment.utc(timestamp).format(`dd DD MMM YYYY`);
  };
  const getHour = (timestamp) => {
    return moment.utc(timestamp).format(`HH:mm`);
  };

  if (timestamps.start && !timestamps?.end)
    return `${getDate(timestamps.start)} ${t("scheduler.at")} ${getHour(
      timestamps.start
    )}`;
  if (timestamps.start && timestamps.end)
    return `${getDate(timestamps.end)} - ${getDate(timestamps.start)}`;
  return "";
}

function TimelineSubheader({ timestamps }) {
  return <Typography variant="body2">{useTime(timestamps)}</Typography>;
}

function TimelineHeader({ title, creator, type }) {
  const { t } = useTranslation();
  const {
    app: {
      client: { alias },
    },
  } = useContext(AppContext);
  const getTranslationKey = () => {
    switch (type) {
      case 0:
      case 1:
      case 3:
        return "timeline.completed";
      case 2:
        return "timeline.pressed";
      case 4:
      case 5:
        return "timeline.installed";
      default:
        return "timeline.completed";
    }
  };
  return (
    <div style={{ display: "block", alignItems: "center" }}>
      <Typography variant="body2">
        <Trans i18nKey={getTranslationKey()} alias={alias} title={title}>
          {{ alias }} has completed {{ title }}
        </Trans>
        {creator !== "" ? (
          <span>
            {" "}
            • {t("timeline.sendBy")} {creator}
          </span>
        ) : null}
      </Typography>
    </div>
  );
}

function TimelineText({
  title,
  creator,
  timestamps,
  hasSubheader = true,
  type = 0,
}) {
  return (
    <div>
      <TimelineHeader title={title} creator={creator} type={type} />
      {hasSubheader ? <TimelineSubheader timestamps={timestamps} /> : null}
    </div>
  );
}

export default TimelineText;
